import capitalize from './capitalize';

const capitalizeForm = (e, setFieldValue) => {
  setFieldValue(e.target.name, capitalize(e.target.value));
};

export default capitalizeForm;
